import { render, staticRenderFns } from "./IntractDropDownMenu.vue?vue&type=template&id=2c670ccd"
import script from "./IntractDropDownMenu.vue?vue&type=script&lang=js"
export * from "./IntractDropDownMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports